import { cartIdHeader, buildHeaders } from "@wff/configs/HeadersConfig";
import api from "./api";
import RestEndpoints from "./constants/RestEndpoints";

export interface IAddItemToFavoritesPayload {
  sku: string[];
}

export const apiGetFavorites = (listId = "default") => {
  return Promise.resolve(
    api.get<any>(`${RestEndpoints.FAVORITES.ENDPOINT}/${listId}`)
  );
};

export const apiAddItemToFavorites = (
  payload: IAddItemToFavoritesPayload,
  listId = "default"
) => {
  const headers = buildHeaders(cartIdHeader);
  return Promise.resolve(
    api.post<any>(`${RestEndpoints.FAVORITES.ENDPOINT}/${listId}`, payload, {
      headers,
    })
  );
};

export const apiRemoveItemFromFavorites = (
  payload: string,
  listId = "default"
) => {
  const headers = buildHeaders(cartIdHeader);
  return Promise.resolve(
    api.delete<any>(
      `${RestEndpoints.FAVORITES.ENDPOINT}/${listId}/${payload}`,
      { headers }
    )
  );
};
